module.exports = __webpack_public_path__ + "img/company-partner.bdf36a2e.png";